import React from "react";
import Header from "../../components/Home/Header";
import LogoContainer from "../../components/Home/LogoContainer";
import ICVCertification from "../../components/Home/ICVCertification";
import Support from "../../components/Home/Support";
import ISOCompliance from "../../components/Home/ISOCompliance";
import ClientTestimonial from "../../components/Home/ClientTestimonial";
import FAQ from "../../components/Home/FAQ";
import FAQs from "../../components/Home/FAQs";

const Home = () => (
  <div>
    <Header />
    <LogoContainer />
    <ICVCertification />
    {/* <Support /> */}
    <ISOCompliance />
    {/* <ClientTestimonial /> */}
    {/* <FAQ /> */}
    <FAQs />
  </div>
);

export default Home;
